import { createFileRoute, Link } from '@tanstack/react-router';
import { FileText, Shield, Lock, Scale } from 'lucide-react';

export const Route = createFileRoute('/legal/')({
  component: LegalIndexPage,
  head: () => ({
    meta: [
      { title: 'Legal | Matricks' },
      { name: 'description', content: 'Matricks legal documents including Terms of Service, Privacy Policy, Security, and Compliance information.' },
    ],
  }),
});

const legalPages = [
  {
    title: 'Terms of Service',
    description: 'Our terms and conditions for using the Matricks platform.',
    href: '/legal/terms',
    icon: FileText,
  },
  {
    title: 'Privacy Policy',
    description: 'How we collect, use, and protect your personal information.',
    href: '/legal/privacy',
    icon: Lock,
  },
  {
    title: 'Security',
    description: 'Our security practices, certifications, and how we protect your data.',
    href: '/legal/security',
    icon: Shield,
  },
  {
    title: 'Compliance',
    description: 'Our compliance certifications including SOC 2, GDPR, and HIPAA.',
    href: '/legal/compliance',
    icon: Scale,
  },
];

function LegalIndexPage() {
  return (
    <div className="not-prose">
      <h1 className="text-3xl font-bold mb-4">Legal</h1>
      <p className="text-muted-foreground mb-8">
        Find all the legal documents and policies governing your use of Matricks.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {legalPages.map((page) => (
          <Link
            key={page.href}
            to={page.href}
            className="rounded-xl border bg-card p-6 hover:border-primary/50 transition-colors"
          >
            <div className="flex items-start gap-4">
              <div className="h-12 w-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                <page.icon className="h-6 w-6 text-primary" />
              </div>
              <div>
                <h2 className="font-semibold text-lg">{page.title}</h2>
                <p className="text-muted-foreground text-sm mt-1">{page.description}</p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
